import { Injectable } from '@angular/core';
import { Role } from '../models/role.model';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService {

  constructor(private http: HttpClient, private loading: LoadingService) {}

  getAllRoles(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/roles/get-all`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }
  getRoleByID(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/roles/get-one/${id}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }
  getAllPermissions(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/roles/permissions/get-all`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
  addNewRole(payload: Role): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${SETTINGS.BASE_API}/roles/create`, payload).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }
  editRole(payload: Role): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put(`${SETTINGS.BASE_API}/roles/update`, payload).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }
}
